/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AppDataResponse,
  HTTPValidationError
} from './client.schemas'




/**
 * @summary Get App Data
 */
export const appDataGetAppData = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AppDataResponse>> => {
    
    return axios.default.get(
      `/app_data`,options
    );
  }


export const getAppDataGetAppDataQueryKey = () => {
    return [`/app_data`] as const;
    }

    
export const getAppDataGetAppDataQueryOptions = <TData = Awaited<ReturnType<typeof appDataGetAppData>>, TError = AxiosError<HTTPValidationError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appDataGetAppData>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppDataGetAppDataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appDataGetAppData>>> = ({ signal }) => appDataGetAppData({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appDataGetAppData>>, TError, TData> & { queryKey: QueryKey }
}

export type AppDataGetAppDataQueryResult = NonNullable<Awaited<ReturnType<typeof appDataGetAppData>>>
export type AppDataGetAppDataQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get App Data
 */
export const useAppDataGetAppData = <TData = Awaited<ReturnType<typeof appDataGetAppData>>, TError = AxiosError<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appDataGetAppData>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppDataGetAppDataQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



